import { useIsDownSm } from 'hooks/useMediaQueries';

import { TenantLogo } from 'components/TenantLogo/TenantLogo';

import { useTenantId } from 'hooks/useTenantId';

import style from './Header.module.css';
import Links from './components/Links';
import Logo from './components/Logo';
import BurgerMenu from './components/BurgerMenu/BurgerMenu';

const Header = () => {
  const tenantId = useTenantId();
  const isDownSm = useIsDownSm();

  return (
    <div className={style.container}>
      {isDownSm && tenantId ? <TenantLogo className={style.tenantLogo} /> : <Logo />}

      {/* Desktop*/}
      <div className={style.nav}>
        <Links />
      </div>

      {/* Mobile */}
      <BurgerMenu />
    </div>
  );
};

export default Header;
